export default function visitComment() {
	// do nothing
}
